export default class Validate {

    required(val) {
        if (val == undefined) {
            return false
        }

        if (typeof val == 'string') {  // TODO: refactor this
            if (val.trim() == '') {
                return false
            }
        }

        return true
    }
}